import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import Account from "./pages/Account";
import Coaching from "./pages/Coaching";
import AuthCallback from "./components/AuthCallback";
import Header from "./components/Header";
import Footer from "./components/Footer";
import CartDrawer from "./components/CartDrawer";
import ChatWidget from "./components/ChatWidget";
import Home from "./pages/Home";
import Articles from "./pages/Articles";
import ArticleDetail from "./pages/ArticleDetail";
import Issues from "./pages/Issues";
import Reader from "./pages/Reader";
import Shop from "./pages/Shop";
import Subscribe from "./pages/Subscribe";
import Submit from "./pages/Submit";
import Contact from "./pages/Contact";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import Admin from "./pages/Admin";

function SmoothScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);
  useEffect(() => {
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const { pathname, hash } = useLocation();
  const bare = pathname.startsWith("/reader") || pathname.startsWith("/admin");
  if (hash?.includes("session_id=") || hash?.includes("login_code=")) return <AuthCallback />;
  return (
    <>
      <SmoothScroll />
      {!bare && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/articles" element={<Articles />} />
          <Route path="/article/:slug" element={<ArticleDetail />} />
          <Route path="/issues" element={<Issues />} />
          <Route path="/reader/:issueId" element={<Reader />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/subscribe" element={<Subscribe />} />
          <Route path="/submit" element={<Submit />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/coaching" element={<Coaching />} />
          <Route path="/account" element={<Account />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!bare && <Footer />}
      <CartDrawer />
      {!bare && <ChatWidget />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <Shell />
          <Toaster position="bottom-left" />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
